/**
 * REMOVE BODY ONLOAD LAYER
 * Remove the body layer after bootstrap's plugins ( menu, etc...) are loaded
 *
 * Applay the background gradient to the body starting from a element position
 */
export default function bodyLoaded() {
    /**
     * Remove the body layer after bootstrap's plugins ( menu, etc...) are loaded
     */
    document.body.classList.remove('body-loading');
    const bodyLoader = document.querySelector('.body-loader');

    // Fade out (remove when the CSS animation finishes)
    bodyLoader.addEventListener('animationend', function () {
        this.style.display = 'none';
    });
    bodyLoader.classList.add('fadeout');

    /**
     * Apply the body gradient from the starting element position,
     * + optional offset, to the bottom of the document
     */
    const bodyGradient = document.querySelector('.body-gradient-start');
    if (!bodyGradient) return;

    setTimeout(updateGradientBottomPosition, 250);
    updateGradientBottomPosition();

    function updateGradientBottomPosition() {
        const gradientStart = bodyGradient.offsetTop;
        const gradientStartOffset = parseInt(
            getComputedStyle(bodyGradient).getPropertyValue(
                '--gradient-start-offset'
            )
        );
        // get body element height
        const docHeight = document.body.offsetHeight;
        let height = docHeight - gradientStart;
        height -= gradientStartOffset;

        bodyGradient.style.setProperty(
            '--gradient-bottom-position',
            height + 'px'
        );
    }

    // Update the gradient bottom position on window resize with debounce
    let resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            updateGradientBottomPosition();
        }, 250);
    });
}
